<script>
  /* eslint-disable no-use-before-define */
  import YearInput from './year-input/year-input.svelte'
  import { nrkLogoNrk } from '@nrk/core-icons/logo'
  import Promos from './promos.svelte'

  export let age = 0
  export let showYearInput = false
</script>

<footer>
  <hr class="footer-header" />
  <div class="footer-body">
    {#if showYearInput}
      <YearInput
        predefinedAge={age}
        labelText="Prøv et annet år her"
        showAgeSelect={false}
        titleSize="small"
      />
    {/if}
    <div class="footer-content">
      <Promos />
    </div>
    <div class="footer-body-bottom">
      <a href="https://www.nrk.no" class="logo">
        {@html nrkLogoNrk}
      </a>
      <a href="https://www.nrk.no/etikk/redaktoransvar-pa-nrk.no-1.2843526" class="colophon">
        <ul>
          <li>Ansvarlig redaktør: Vibeke Fürst Haugen</li>
          <li>Nettsjef: Hildegunn Soldal</li>
        </ul>
      </a>
      <a href="https://www.nrk.no/etikk/opphavsrett-pa-nrk.no-1.2843522" class="copyright">
        Opphavsrett NRK © 2023
      </a>
    </div>
  </div>
</footer>

<style>
  footer {
    position: relative;
    z-index: 1;
    width: 100%;
    margin: 0;
    color: #fff;
  }

  .footer-header {
    display: block;
    margin: 0;
    width: 100%;
    height: 112px;
    border: none;
    background: url('../assets/sno_skjot.svg');
    background-repeat: repeat-x;
    background-position: center bottom;
  }

  .footer-body {
    padding-top: 100px;
    width: 100%;
    background: #061629;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 60px;
  }

  .footer-body-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding-bottom: 30px;
  }

  .logo {
    background: transparent;
    color: #fff;
    font-size: 1.7rem;
  }

  .colophon ul {
    list-style: none;
    text-align: center;
    padding: 0;
    margin: 0;
  }
  .copyright,
  .colophon {
    font-size: 16px;
    text-decoration: none;
  }

  .copyright {
    font-weight: 560;
  }
</style>
